<template>
  <div class="user-setting">
    <div class="spin-margin" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <ul v-if="!loading">
      <li>
        <h5>基本设置</h5>
        <headerIcon :edit="true" :Action="Action"></headerIcon>
      </li>
      <li v-for="(item, index) in userList" :key="index">
        <h6>{{ item.title }}</h6>
        <p>{{ item.text }}</p>

        <div class="edit-phone" v-if="item.title == '手机号码'">
          <p
            v-if="userList[1].text == '未绑定' && item.title == '手机号码'"
            @click="editModal('wx')"
          >
            绑定手机号码
          </p>
          <p
            v-if="
              item.title == '手机号码' &&
                userList[1].text !== '未绑定' &&
                userList[2].text !== '未绑定'
            "
            @click="editModal('phone')"
          >
            修改
          </p>
        </div>
        <div class="edit-phone" v-if="item.title == '微信'">
          <p
            v-if="userList[2].text == '未绑定' && item.title == '微信'"
            @click="wxBindMobile"
          >
            绑定微信
          </p>
        </div>
      </li>
    </ul>
    <a-modal
      v-model="visible"
      title="修改手机号"
      cancelText="取消"
      okText="确定"
      class="form-all"
      :footer="false"
    >
      <b-form @submit="onSubmit">
        <b-form-group id="phone" label-for="phone" class="login-input">
          <b-form-input
            id="input-phone"
            v-model="form.phone"
            placeholder="手机号码"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group id="code" label-for="code" class="login-input login-code">
          <b-form-input
            id="input-phone"
            v-model="form.code"
            placeholder="验证码"
            required
          ></b-form-input>
          <b-button @click="onVerification" :disabled="disableVal">{{
            time
          }}</b-button>
        </b-form-group>
        <b-button
          :disabled="disabled"
          class="login-button"
          :class="[
            disabled ? 'login-button-disable' : 'login-button-undisable'
          ]"
          type="submit"
          block
          >{{ modeType == "phone" ? "修改" : "绑定" }}</b-button
        >
      </b-form>
    </a-modal>
  </div>
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      user: {},
      modeType: "",
      disableVal: false,
      disabled: true,
      visible: false,
      check: false,
      loading: false,
      time: "发送验证码",
      form: {
        phone: "",
        code: ""
      },
      userList: [
        {
          title: "昵称",
          text: ""
        },
        {
          title: "手机号码",
          text: ""
        },
        {
          title: `微信`,
          text: ""
        },
        {
          title: "邮箱",
          text: ""
        }
      ]
    };
  },
  watch: {
    form: {
      handler(val) {
        if (val.phone == "" || val.code == "") {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loginWxchat();
  },
  methods: {
    editModal(type) {
      this.modeType = type;
      this.visible = true;
      this.form.phone == "";
      this.form.code == "";
    },
    async onSubmit(event) {
      event.preventDefault();
      let token = sessionStorage.getItem("edit_token");
      let query = {
        verifyMobile: this.form.phone,
        verifyCode: this.form.code,
        verifyToken: token
      };
      try {
        if (this.modeType == "wx") {
          const data = await Api.User.bindMobile(query);
          if (data) {
            this.$message.success("绑定成功");
            this.visible = false;
            this.getUser();
          }
        } else {
          const data = await Api.Login.editPhone(query);
          if (data) {
            this.$message.success("修改成功");
            this.visible = false;
            this.getUser();
          }
        }
      } catch (e) {
        if (this.modeType == "wx") {
          this.$message.error("绑定失败，该手机号可能已被绑定");
        } else {
          this.$message.error("修改失败，该手机号可能已被绑定");
        }
      }
    },
    async onVerification() {
      if (this.form.phone == "") {
        this.$message.error("手机号不能为空");
        return false;
      } else {
        let query = {
          mobile: this.form.phone,
          tpl: "login_verify_code"
        };
        try {
          let time = 60;
          let timer = setInterval(() => {
            time--;
            this.time = `${time}秒后重试`;
            this.disableVal = true;
            if (time == 0) {
              clearInterval(timer);
              this.time = "发送验证码";
              this.disableVal = false;
            }
          }, 1000);
          const data = await Api.Login.getVerification(query);
          sessionStorage.setItem("edit_token", data.token);
        } catch (e) {
          this.$message.error(e);
        }
      }
    },
    //手机号绑定微信
    async wxBindMobile() {
      try {
        const url = "https%3A%2F%2Fwww.huicaihuineng.com%2Fuser%2Fsetting";
        const data = await Api.Login.LoginWeChatScan(url);
        window.location.href = data;
        this.getUser();
      } catch (e) {
        this.$message.error("绑定失败,微信号可能已被绑定");
      }
    },
    //获取路由后携带code值进行绑定
    async loginWxchat() {
      this.getUser();
      let router = this.$route.query;
      if (router.code) {
        try {
          const data = await Api.User.bindwechat(
            "wx33bc1debb6840ca0",
            router.code
          );
          if (data) {
            this.$router.push({ query: {} });
            this.getUser();
            this.$message.success("绑定成功");
          }
          sessionStorage.setItem("wechat_token", JSON.stringify(data));
        } catch (e) {
          this.$message.error("绑定失败,手机号可能已被绑定");
          this.$router.push({ query: {} });
        }
      } else {
        this.getUser();
      }
    },
    Action(type) {
      this.$router.push("/user/setting/edit");
      console.log(type);
    },
    async getUser() {
      this.loading = true;
      try {
        const data = await Api.User.getUser();
        this.userList[0].text = data.nickname || "";
        this.userList[1].text = data.mobile || "未绑定";
        this.userList[2].text = data.wxUnionid ? "已绑定" : "未绑定";
        this.userList[3].text = data.info.email || "";
        this.loading = false;
      } catch (e) {
        this.$message.error(e);
      }
    }
  }
};
</script>
<style scoped>
.user-setting li {
  display: flex;
  align-items: center;
  padding: 0px 0px 34px 0px;
}
.user-setting li h5 {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 36px;
  margin-bottom: 0 !important;
  text-align: left;
  flex: 1;
}
.user-setting li:first-of-type {
  border-bottom: 1px solid #f7f8ff;
}
.user-setting li:nth-of-type(2) {
  margin-top: 30px;
}
.user-setting li h6 {
  font-size: 20px;
  font-weight: 300;
  color: #333333;
  line-height: 30px;
  margin-bottom: 0px !important;
}
.user-setting p {
  font-size: 20px;
  font-weight: 300;
  color: #666666;
  line-height: 30px;
  margin-left: 42px;
}
.edit-phone {
  color: #99c1ff !important;
  margin-left: auto !important;
  display: flex;
}
.edit-phone p {
  color: #99c1ff !important;
  margin-left: 10px;
  cursor: pointer;
}
</style>
